<template>
<transition name="confirm-fade">
  <div class="dragMoDal" :style="{width:width,top:top,zIndex:zIndex}" v-show="visible">
    <slot name="header">
      <div class="dragMoDal-header" @mousedown="mousedown">
        <div class="dragMoDal-title">
          <span class="dragMoDal-title-text">{{title}}</span>
          <span class="dragMoDal-title-text" v-if="subTitle">{{subTitle}}</span>
          <span class="dragMoDal-title-tip">{{$t('drag_title_bar_to_move')}}</span>
        </div>
        <span class="dragMoDal-close" @click.stop="onClose">{{$t('close')}}</span>
      </div>
    </slot>
    <div class="dragMoDal-body">
      <slot></slot>
    </div>
    <slot name="footer">
      <div class="dragMoDal-footer">
        <a-button type="primary" @click="onOk">
          {{okText || $t('common_search')}}
        </a-button>
        <a-button type="default" style="margin-left:10px;" @click="onCancel">
          {{cancelText || $t('common_reset')}}
        </a-button>
      </div>
    </slot>
  </div>
</transition>
</template>

<script>
export default {
  props:{
    visible:{
      type:Boolean,
      default:true
    },
    title:{
      type:String,
      default:''
    },
    subTitle:{
      type:String,
      default:''
    },
    width:{
      type:String,
      default:'420px'
    },
    zIndex:{
      type:Number,
      default:900
    },
    top:{
      type:String,
      default:'10%'
    },
    okText:{
      type:String,
      default:''
    },
    cancelText:{
      type:String,
      default:''
    }
  },
  watch:{
    visible(newVal){
      if(newVal){
        this.initPosition();
      }
    }
  },
  mounted(){
    let _this = this;
    this.$nextTick(() => {
      document.body.appendChild(this.$el);
      _this.$el.style.left = (document.body.clientWidth - parseInt(_this.width)) + 'px';
      window.addEventListener('resize',_this.setPos);
    })
  },
  beforeDestroy(){
    let _this = this;
    document.body.removeChild(_this.$el);
    window.removeEventListener('resize',_this.setPos);
  },
  methods:{
    onOk(){
      this.$emit('ok')
    },
    onCancel(){
      this.$emit('cancel')
    },
    onClose(){
      this.$emit('close')
    },
    initPosition(){
      let _this = this;
      _this.$nextTick(() => {
        _this.$el.style.top = _this.top;
        _this.$el.style.left = (document.body.clientWidth - parseInt(_this.width)) + 'px';
      })
    },
    mousedown(e){
      let _this = this;
      if(e.target !== this.$el.querySelector('.dragMoDal-close')){
        this.ex = e.clientX;
        this.ey = e.clientY;
        const elW = this.$el.clientWidth
        const elH = this.$el.clientHeight
        const ElLeft = this.$el.offsetLeft
        const ElTop = this.$el.offsetTop
        const OffW = this.ex - ElLeft;
        const OffH = this.ey - ElTop;
        document.onmousemove = function(event){
          event.preventDefault()
          let newX = event.clientX;
          let newY = event.clientY;

          let newLeft = newX - OffW;
          let newTop = newY - OffH;
          if(newLeft > document.body.clientWidth - _this.$el.offsetWidth){
            newLeft = document.body.clientWidth - _this.$el.offsetWidth;
          }else if(newLeft < 0){
            newLeft = 0;
          }
          if(newTop > document.body.clientHeight - _this.$el.offsetHeight){
            newTop = document.body.clientHeight - _this.$el.offsetHeight;
          }else if(newTop < 0){
            newTop = 0;
          }
          _this.$el.style.left = newLeft+'px';
          _this.$el.style.top = newTop+'px';
        }
        document.onmouseup = function(){
          document.onmousemove = null
          document.onmouseup = null
        }
      }
    },
    setPos(){
      let _this = this;
      let left = this.$el.offsetLeft;
      let top  = this.$el.offsetTop;
      const elW = this.$el.clientWidth
      const elH = this.$el.clientHeight
      if(left > document.body.clientWidth - parseInt(_this.width)){
        left = document.body.clientWidth - parseInt(_this.width);
      }else if(left < 0){
        left = 0;
      }
      if(top > document.body.clientHeight - this.$el.offsetHeight){
        top = document.body.clientHeight - this.$el.offsetHeight
      }else if(top < 0){
        top = 0;
      }
      _this.$el.style.left = left+'px';
      _this.$el.style.top = top+'px';
    }
  },
  data(){
    return {
      ex:0,
      ey:0
    }
  }
}
</script>

<style lang="less" scoped>

.dragMoDal{
  position: fixed;
  background: #fff;
  padding-bottom:10px;
	box-shadow: 0px 0px 8px 0px 
		rgba(0, 0, 0, 0.25);
	border: solid 1px rgba(0, 0, 0, 0.15);
}
.dragMoDal-header{
  display:flex;
  padding: 0 10px;
  align-items: center;
	height: 40px;
	background-color: rgba(248, 248, 248, 1);
	border-radius: 2px;
	border-bottom: solid 1px rgba(216, 216, 216, 1);
  user-select: none;
  cursor:move;
  .dragMoDal-title{
    flex:1;
    margin-right:10px;
  }
  .dragMoDal-title-text{
    font-size:16px;
    color: rgba(0, 0, 0, 0.85);
  }
  .dragMoDal-title-tip{
    margin-left:5px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.25);
    margin-left:10px;
  }
  .dragMoDal-close{
    color:rgba(250, 85, 76, 1);
    cursor: pointer;
  }
}
.dragMoDal-body{
  padding: 10px;
  max-height:calc(~"100vh - 120px");
  overflow: auto;
}
.dragMoDal-footer{
  text-align: center;
  padding: 10px;
}

 .confirm-fade-enter-active {
    animation: opacity 0.3s;
  }
 
  .confirm-fade-leave-active {
    animation: outOpacity 0.2s;
  }
  /* 进来的动画 */
  @keyframes opacity {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
 
  /* 出去的动画 */
  @keyframes outOpacity {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
</style>